import * as ReactDOM from 'react-dom';
import React, { Component, useState, useEffect,createElement  } from 'react';
import Usersession from './Usersession';
import axios from 'axios';
import Configdata from './Defaultdata';
import {showhidediv,loadwidgate,clrwidgate,gtdfltvid,setdvl,openemoji,configchat,insertpost,fillmsg,scrolldowncboat} from './userdefaultdata';
import {cleardv} from './clearmem';
import Userpfp from './Userpfp';
import {Chtuser} from './Userchat';
import EmojiPickercomp from './Emoji';
import {Userpmusers,pvtmus,resizepmusr} from './Userpmgs';
export default class Pvtmsgbox extends Component{
  state = {
	togglevilla:false,
        villatype:0,
	url: "",
	toggleinfo:false,
	isfpfp:true,
	vnm:'My villa',
        togglemoji:false,
	rumsgid:0,
         messg:'',
    };

msgkevt(e: any){
 	// alert('ssg text');
	const msctb = document.getElementById('msgctxt') as HTMLInputElement;
       

        var tx = msctb.value ;
       if(tx !== null && tx != "")
        
	this.sendchat(tx)
         this.setState({ messg: '' });
          // alert(this.state.messg);
        // msctb.value = '';
       
	e.preventDefault();
	
 }
textboxChange(e:any){
   const txt = e.target.value;
  this.setState({ messg: txt });
   e.preventDefault();

}
sendchat(txt:any){
const clrcd = Usersession.getColorcode();

const userid = Usersession.getUserId();
const dvid = localStorage.getItem("dvillaid");
const vtpid = localStorage.getItem("vilaty");
const objuser = Usersession.getUserpfp();
const pfid = objuser.pfpid;
const utp = objuser.utf;
const name = objuser.uname;
const ruisrid = Usersession.getRcvmsguserid();

const clrcode = Usersession.getColorcode();

//alert(userid);
//alert(ruisrid);

const apimsgurl = '/insertpvtmsgroom';

const fu = utp?'0':'1';

const obj = {sendid:userid,receiveid:ruisrid,message:txt,pfpid:pfid,ccd:clrcode,isf:fu,insert:'1'};

this.insertumsg(apimsgurl,obj);
// this.savechat(userid,dvid,vtpid,txt,clrcd,pfid,utp,name);
  
}
savechat(usrid:any,vlaid:any,vtpid:any,tx:any,colorcd:any,pfid:any,utp:any,nm:any){
try {
		//alert(vlaid);
		let url = Configdata.srvurl + '/addchatmsg';
                if(vtpid == 2) url = Configdata.srvurl + '/addchatmsgp';

                const response = axios.post(url, {
    		uid: usrid,
		vid: vlaid,
    		vtd: vtpid,
    		ccod:colorcd,
                msg: tx,
		pfpid:pfid,
		utype:utp,
		uname:nm,
		
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		 
		const usercd = result.data;
		configchat(usercd);
	        });		
              }
		
	   
          }
        catch (e) {
           // debugger;
		
        }

}
insertumsg(url:any,jsondata:any){
        
	 try {
	        
		
                const response = axios.post(Configdata.srvurl + url,jsondata, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
                fillmsg(usercd,true);
                //let responddata = JSON.stringify(usercd);	
		//alert(responddata);	
	        });		
              
	     }
	   }
         
        catch (ex:any) {
           // debugger;
		//wrongmsg();
        }
      
}

kevtemoji(e:any){
Usersession.setEmojchat(false);
const emosts = !this.state.togglemoji;
//alert(emosts);
Usersession.setEmojchat(emosts);

openemoji(emosts);
this.setState({ togglemoji: emosts });
e.preventDefault();

}
kevts(e: any){
 	// alert('ok');

	e.preventDefault();
	
    }
s(e: any){
 	
	e.preventDefault();
	
    }
setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
clrall(){
        showhidediv(true,'chattypedivtop');
 	this.setState({ togglevilla: true });

        showhidediv(true,'chatprofiledivtop');
	this.setState({ toggleinfo: true });
	clrwidgate('wigtarea');
}
displaychat(e:any){
this.clrall();
 e.preventDefault();

}
setvillatype(e:any){
 const svt = !this.state.togglevilla;
 showhidediv(svt,'chattypedivtop');
 this.setState({ togglevilla: svt });

 e.preventDefault();
}
 setprofile(e:any){
 const svt = !this.state.toggleinfo;
 showhidediv(svt,'chatprofiledivtop');
  this.setState({ toggleinfo: svt });

 //this.showhidevillas(svt);
 e.preventDefault();

}
showprivatevilla(e:any){
	this.clrall();
	loadwidgate('wigtarea',2);
	this.showhidevillas(true);
         e.preventDefault();

}

showpublicvilla(e:any){
	this.clrall();
	loadwidgate('wigtarea',1);
	this.showhidevillas(true);
         e.preventDefault();

}
showhidevillas(ishide:any){
	showhidediv(true,'chattypedivtop');
	this.setState({ togglevilla: ishide });
}
showmessage(e:any){
 const userid = Usersession.getUserId();
 pvtmus(userid);
 e.preventDefault();

}

msgboxclose(e:any){
clrwidgate('msgarea');
showhidediv(true,'msgarea');
resizepmusr('97vh','pvtmsgusers');
resizepmusr('97vh','wigtarea');

}
setpvtmsgdiv(){
const rid = Usersession.getRcvmsguserid();
const userid = Usersession.getUserId();
const apimsgurl = '/getpvtmsgroom';



const obj = {sendid:userid,receiveid:rid};

}
componentDidMount() {
        const ruid = Usersession.getRcvmsguserid();
       this.setState({ rumsgid: ruid });
        this.setpvtmsgdiv();
        //debugger;
     	//alert('test');
        //this.clrall();
         //setdvl();
        // loadwidgate('vilnm',3);
         
    	}
       

render() {

return(
 <div>
 	<div>
		 
          	   <div id="pvtmsg" className="per100">
               		 <div style={{height:'40px'}} className="search-title-bar">
                     		<a href="#" title="Message">
                       		<div className="search-title">
			 	<span className="search-title"> Message Box</span>
				</div>
                      		</a>
		    		<a href="#" onClick={e => this.msgboxclose(e)} title="Profile">
				<div className="search-title-toggle" id="togglesearch">
			  	X
				</div>
				</a>	
                 
              		   </div>
			   <div id="pvtmsgareascrol" style={{height:'40vh',width:'100%',overflowY:'auto'}}>
				<div id="usrpvtmsgarea" style={{height:'auto',width:'100%'}}>

			        </div>
			   </div>		
	   	           <div>
				<div id="msginputdiv">
         				<div className="c-txtcontainer" style={{width:'85%',left:'6vw'}}>
		
		
				<input id="msgctxt" onChange={e => this.textboxChange(e)} type="text" className="cu-txtbox"/>
	     	
	       				</div>
	 				<div>
					 <a href="#" className="blanka"  onClick={e=>this.msgkevt(e)} title="Send" >	
    					  <div className="btnentr">
						^
    					</div> 
    					</a>

					</div>
					<div>
						<a href="#" className="blanka"  onClick={e=>this.kevtemoji(e)} title="Emoji" >	
    						<div className="btnemoji">
						<span className="emospan">e</span>
   						 </div> 
    						</a>
					</div>
				</div>
				

	      		   </div>

    	 	   </div>	

    </div>
 </div>
	
);
}
}